export class CarModel {
    car_id: any;
    brand_id: any = "";
    year: any;
    family_id: any;
    model_id: any;
}

export class UserModel {
    nombre: any;
    apellido: any;
    fecha_nacimiento: string = "1900-01-01";
    sexo: number = 1;
    telefono: any;
    mail: any;
}

export class AddressModel {
    province_id: any;
    locality_id: any;
}

export class CompanyModel {
    id: any;
    nombre: any;
}

export class CoverageModel {
    id: any;
    nombre: any;
}

export class CoberturaProductosModel {
    id: any;
    cotizadorId: any;
    data: any = [];
}
